import OptionButton from '../optionButton/optionButton'
import OptionSelect from '../optionSelect/optionSelect'
import styles from './facetSection.module.scss'

import Typography from 'Atoms/Typography'

const FacetSection = ({ facetInfo, selectedFacetId, setSelectedFacetId }) => {
  const facets = facetInfo?.facets
  const useSelect = facets?.length > 3

  return (
    <div className={styles.container}>
      <Typography font={'bold'} size={1}>
        {facetInfo?.displayName}
      </Typography>
      {useSelect ? (
        <div className={styles.facetContainer}>
          <OptionSelect
            facetOptions={facets}
            selectedFacetId={selectedFacetId}
            setSelectedFacetId={setSelectedFacetId}
            testingName={facetInfo?.displayName}
          />
        </div>
      ) : (
        <div className={styles.facetButtonContainer}>
          {(facets || []).map((facet, facetIndex) => {
            return (
              <OptionButton
                key={'facet_option_button_' + facetIndex}
                isSelected={selectedFacetId === facet.id}
                displayName={facet.name}
                onClick={() => setSelectedFacetId(facet.id)}
                classNames={styles.facetButton}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default FacetSection
